// src/pages/admin/Page_REVI/Page_REVI.js
//
// M11 - Pagina contenedora del panel REVI admin. Agrupa todas las
// gestiones de la vertical REVI bajo una sola ruta /admin/revi con
// tabs internos. URL legacy /admin/reviscene redirige a ?tab=scenes
// para no romper bookmarks (ver AdminRouter).
//
// ESTRATEGIA "wrap, don't rewrite":
// - Tab Scenes renderiza Page_ReviScene legacy SIN tocarlo.
// - Tab Formacion es nuevo (Page_REVI_Formacion).

import React, { useMemo } from "react";
import { Tabs } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  AppstoreOutlined,
  BankOutlined,
  ReadOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import { PageHeader, EducaThemeProvider } from "../../../ui";
import { Page_ReviScene } from "../Page_ReviScene";
import { Page_REVI_Formacion } from "./Page_REVI_Formacion";
import { Page_REVI_MotricityGames } from "./Page_REVI_MotricityGames";
import { Page_REVI_Instituciones } from "./Page_REVI_Instituciones";
import styles from "./Page_REVI.module.scss";

// Nota: los nombres `Page_ReviScene` y `Page_REVI_Formacion` mantienen
// el snake_case del codebase legacy (todas las paginas admin usan
// Page_*). ESLint marca 2 warnings react/jsx-pascal-case que aceptamos
// por coherencia. No afectan build ni CI.
/* eslint-disable react/jsx-pascal-case */
export const REVI_TABS = [
  {
    key: "scenes",
    label: "Scenes",
    icon: <AppstoreOutlined />,
    render: () => <Page_ReviScene />,
  },
  {
    key: "formacion",
    label: "Formación",
    icon: <ReadOutlined />,
    render: () => <Page_REVI_Formacion />,
  },
  {
    key: "motricity-games",
    label: "Juegos Motricidad",
    icon: <ThunderboltOutlined />,
    render: () => <Page_REVI_MotricityGames />,
  },
  {
    key: "instituciones",
    label: "Instituciones",
    icon: <BankOutlined />,
    render: () => <Page_REVI_Instituciones />,
  },
];
/* eslint-enable react/jsx-pascal-case */

const DEFAULT_TAB = "scenes";
const TAB_KEYS = new Set(REVI_TABS.map((t) => t.key));

function normalizeTab(value) {
  return value && TAB_KEYS.has(value) ? value : DEFAULT_TAB;
}

export function Page_REVI() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeKey = normalizeTab(searchParams.get("tab"));

  const items = useMemo(
    () =>
      REVI_TABS.map((t) => ({
        key: t.key,
        label: (
          <span
            style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
          >
            {t.icon}
            {t.label}
          </span>
        ),
        children: t.render(),
      })),
    [],
  );

  const onChange = (key) => {
    navigate(`/admin/revi?tab=${key}`, { replace: false });
  };

  return (
    <EducaThemeProvider>
      <div className={styles.pageREVI}>
        <PageHeader
          title="REVI"
          subtitle="Gestion de la plataforma REVI: escenas terapeuticas, formacion de terapeutas e informacion publica."
        />
        <div className={styles.tabsWrapper}>
          <Tabs
            activeKey={activeKey}
            onChange={onChange}
            items={items}
            destroyInactiveTabPane
          />
        </div>
      </div>
    </EducaThemeProvider>
  );
}
